<template>
  <div>
    <Back :backText="$t('mark_back')"></Back>
    <div class="syllabuses_box">
      <div class="syllabuses_box_title1">{{ $t("Compare_syllabuses") }}</div>
      <div class="syllabuses_box_title2">{{ $t("table_shows_syllabuses") }}</div>
      <img src="@/assets/images/hsk/syllabuses.png" alt="" />
      <div class="syllabuses_box_title3">{{ $t("forrgin_lang") }} {{ $t("Second_Language") }}</div>
      <div class="syllabuses_box_university">
        <div class="syllabuses_box_title4">{{ $t("Requirement_entry") }}</div>
        <div class="university_item_chinese1">{{ $t("most_Chinese_universities") }}</div>
        <!-- <div class="university_item_chinese2">{{ $t("Qing_Hua") }}</div> -->
        <!-- <div class="university_item_chinese3">{{ $t("beijing_university") }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Back from "@/components/common/Back";
import { mapGetters } from "vuex";
import analytics from "@/utils/AnalyticsCenter";
export default {
  components: {
    Back,
  },
  computed: {
    ...mapGetters("level", {
      levelActiveObj: "levelActiveObj",
    }),
  },
  created() {
    let mixpanelParams = {
      exam_type: this.levelActiveObj.level_name,
    };
    analytics.logEvent("hskweb_compare_view", mixpanelParams);
  },
};
</script>
<style scoped lang="scss">
.syllabuses_box {
  width: 1200px;
  height: 781px;
  border-radius: 12px;
  border: 1px solid var(--Wohui-BG-2, #efeff1);
  background: var(--Wohui-White, #fff);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  &_title1 {
    color: var(--Wohui-0, #2c2f46);
    font-size: 32px;
    font-weight: 700;
    margin-top: 38px;
  }
  &_title2 {
    color: #000;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    margin-top: 14px;
    margin-bottom: 42px;
  }
  &_title3 {
    color: #000;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    margin-top: 30px;
  }
  &_university {
    display: flex;
    margin-top: 16px;
    .syllabuses_box_title4 {
      color: #000;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
    .university_item_chinese1 {
      padding: 0 5px;
      height: 18px;
      font-size: 14px;
      background: rgba(154, 208, 128, 0.3);
    }
    .university_item_chinese2 {
      padding: 0 5px;
      font-size: 14px;
      height: 18px;
      background: rgba(166, 222, 255, 0.3);
    }
    .university_item_chinese3 {
      padding: 0 5px;
      font-size: 14px;
      height: 18px;
      background: #fceeee;
    }
  }
}
</style>
